import React, { useState, useEffect, useRef } from 'react';

//import para inicio de sesion y consultas
import { onAuthStateChanged } from 'firebase/auth';
import { auth, getUserInfo } from '../../firebase/firebase';

//import para ver permisos
import { hasPermission } from '../../firebase/permisos';

//import para navigate
import { useNavigate } from 'react-router-dom';

//importacion del MENU
import Menu from '../menu';
import HeaderHome from '../header';

//import para funciones especificas de esta pantalla
import { getAllAccounts, deleteAccountById, deleteAccountsByIds } from '../../firebase/cuentas.js'

import { Link } from 'react-router-dom';

//modal de carga
import LoadingModal from '../Loading-Modal/loading.jsx'
import '../Usuarios/usuarios.css';
import '../Requisiciones/requisicion_solicitadas.css'
import '../Requisiciones/historial_requisiciones.css'

//import de iconos
import { AiFillCloseCircle } from 'react-icons/ai';
import { CiMenuKebab } from 'react-icons/ci';
import { GrFormEdit } from 'react-icons/gr';
import { FiTrash2 } from 'react-icons/fi';
import { MdArrowBackIosNew, MdArrowForwardIos } from 'react-icons/md';


import Modal from '../Modal/Modal.jsx'


function CuentasBanco(props) {

    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false); // Estado para controlar el modal de carga


    const [useUser, setUseUser] = useState({
        nombre: '',
        rol: '',
        email: '',
        genero: '',
        fechaIni: '',
        cumple: '',
        tel: '',
        foto: ''
    });

    const [loading, setLoading] = useState(true);
    const hasCheckedPermission = useState(false);
    const [Cuentas, setCuentas] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState({});

    // Estado para rastrear qué proyecto han sido seleccionados
    const [selectedCuentas, setselectedCuentas] = useState([]);
    const [selectAll, setSelectAll] = useState(false); // Estado para el checkbox de la cabecera

    const toggleDropdown = (accountID) => {
        setDropdownOpen(prevState => ({
            ...prevState,
            [accountID]: !prevState[accountID]
        }));
    };

    const dropdownRef = useRef(null);

    //AQUI ESTA EL MODAL
    const [showModal, setShowModal] = useState(false);
    const [showModalForaccountID, setShowModalForaccountId] = useState(null);

    const [showMultiDeleteModal, setShowMultiDeleteModal] = useState(false);


    useEffect(() => {
        if (!hasCheckedPermission.current) {
            onAuthStateChanged(auth, handleCuentastateChanged);
            hasCheckedPermission.current = true;
        }

        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                if (event.target.className !== 'dontCloseDropdown' && !showModal) {
                    setDropdownOpen({});
                }
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, []);


    async function handleCuentastateChanged(user) {
        if (user) {
            setIsLoading(true);
            try {
                const res = await getUserInfo(user.uid);
                if (res != null) {
                    setUseUser(prevState => ({
                        ...prevState,
                        nombre: res.nombre,
                        rol: res.rol,
                        email: res.email,
                        genero: res.genero,
                        fechaIni: res.fechaIni.toDate().toLocaleDateString(),
                        cumple: res.cumple.toDate().toLocaleDateString(),
                        tel: res.tel,
                        foto: res.foto
                    }));

                    //cargar las Cuentas
                    const accountList = await getAllAccounts();
                    setCuentas(accountList);

                    setLoading(false); // para saber si termino de cargar los datos de las Cuentas

                    const canAccess = await hasPermission(res.rol, "cuentas/listado");
                    if (!canAccess) {
                        props.showErr('Usted no tiene permisos para acceder a esta función.')
                        navigate('/home');
                        return;
                    }

                } else {
                    setUseUser(prevState => ({
                        ...prevState,
                        nombre: 'N/A',
                        rol: 'N/A',
                        email: 'N/A',
                        genero: 'N/A',
                        fechaIni: 'N/A',
                        cumple: 'N/A',
                        tel: 'N/A',
                        foto: 'N/A'
                    }));
                }
                setIsLoading(false);
            } catch {
                console.log('NO HAY USUARIO :(');
                navigate('/login');
            }
        } else {
            navigate('/login');
        }
    }


    //AQUI ESTA EL PAGINADOR
    const [currentPage, setCurrentPage] = useState(() => {
        const savedPage = localStorage.getItem('currentPageCuentas');
        return savedPage ? Number(savedPage) : 1;
    });
    const [itemsPerPage] = useState(10);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const [totalPages, setTotalPages] = useState(0);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        localStorage.setItem('currentPageCuentas', pageNumber);
    };
    const [searchName, setSearchName] = useState('');
    const [SearchBanco, setSearchBanco] = useState('');
    const [SearchTipo, setSearchTipo] = useState('');

    const InputChangeUsr = (event) => {
        const { name, value } = event.target;
        if (name === 'nombre') {
            setSearchName(value);
        } else if (name === 'searchbanco') {
            setSearchBanco(value);
        } else if (name === 'searchtipo') {
            setSearchTipo(value);
        }
        if (value) {
            document.getElementById(name).classList.add('input-active');
        } else {
            document.getElementById(name).classList.remove('input-active');
        }

        // Guardar los filtros actualizados en localStorage
        saveFiltersToLocalStorage({
            searchName: name === 'nombre' ? value : searchName,
            SearchBanco: name === 'searchbanco' ? value : SearchBanco,
            SearchTipo: name === 'searchtipo' ? value : SearchTipo
        });
        setExecutionCount(prevCount => prevCount + 1); // Incrementa el contador
    };

    const filteredCuentas = Cuentas.filter(account => {
        const nameMatches = account.name.toLowerCase().includes(searchName.toLowerCase());

        // Solo incluirá Cuentas cuyo banco coincida o, si SearchBanco está vacío, aquellos que tengan el campo vacío.
        const bankMatches = SearchBanco.trim() === '' ?
            (!account.bank || account.bank.toLowerCase().includes(SearchBanco.toLowerCase())) :
            (account.bank && account.bank.toLowerCase().includes(SearchBanco.toLowerCase()));

        // Solo incluirá Cuentas cuyo tipo coincida o, si SearchTipo está vacío, aquellos que tengan el campo vacío.
        const typeMatches = SearchTipo.trim() === '' ?
            (!account.type || account.type.toLowerCase().includes(SearchTipo.toLowerCase())) :
            (account.type && account.type.toLowerCase().includes(SearchTipo.toLowerCase()));

        return nameMatches && bankMatches && typeMatches;
    });

    useEffect(() => {
        setTotalPages(Math.ceil(filteredCuentas.length / itemsPerPage));
    }, [filteredCuentas, itemsPerPage]);

    const [executionCount, setExecutionCount] = useState(0);

    //Restaurar los Filtros desde localStorage al Cargar la Página
    useEffect(() => {
        const savedFilters = JSON.parse(localStorage.getItem('filtersCuentas'));
        if (savedFilters) {
            setSearchName(savedFilters.searchName || '');
            setSearchBanco(savedFilters.SearchBanco || '');
            setSearchTipo(savedFilters.SearchTipo || '');

        }

        const savedPage = localStorage.getItem('currentPageCuentas');

        if (savedPage) {
            setCurrentPage(Number(savedPage));
        }

    }, []);

    useEffect(() => {
        setExecutionCount(prevCount => prevCount + 1); // Incrementa el contador

        const lastURL = localStorage.getItem('lastURL');
        if ((executionCount >= 3) || (lastURL != 'cuentas/listado')) {
            setCurrentPage(1);
            localStorage.setItem('currentPageCuentas', 1);
            localStorage.setItem('lastURL', 'cuentas/listado');
        }
    }, [searchName, SearchBanco, SearchTipo]);

    //SECCION PARA MANEJAR HISTORIAL EN FILTROS POR LOCALSTORAGE

    //Guardar los Filtros en localStorage
    const saveFiltersToLocalStorage = (filters) => {
        localStorage.setItem('filtersCuentas', JSON.stringify(filters));
    };

    const currentItems = filteredCuentas.slice(indexOfFirstItem, indexOfLastItem);


    const [isRoleOpen, setRoleOpen] = useState(false);

    // Efecto para manejar el clic fuera del menú
    useEffect(() => {
        function handleDocumentClick(event) {

            // Verificar si el clic es fuera del menú de roles
            if (isRoleOpen && !event.target.closest('.field-container-usuarios')) {
                setRoleOpen(false);
            }
        }

        document.addEventListener('mousedown', handleDocumentClick);

        return () => {
            document.removeEventListener('mousedown', handleDocumentClick);
        };
    }, [isRoleOpen]); // Dependencias del efecto



    const goToEditaccount = (accountSel) => {
        navigate('./editar', { state: { accountSel } });
    };

    const deleteCuentas = async (accountU) => {

        setIsLoading(true);
        try {
            const result = await deleteAccountById(accountU.id);
            if (result.success) {
                // Actualizar el estado para excluir la cuenta eliminada
                setCuentas(prevCuentas => prevCuentas.filter(pr => pr.id !== accountU.id));
                props.ShowDone(`Se elimino la cuenta: ${accountU.name}`);
            } else {
                // Manejar el caso en que la eliminación falla
                props.showErr(`La cuenta ${accountU.name} no se pudo eliminar.`);
                props.ShowWar(result.message);
            }
            setIsLoading(false);

        } catch (error) {
            console.log(error);
            props.showErr(`La cuenta ${accountU.name} no se pudo eliminar.`);
            setIsLoading(false);
        }

    };

    // Función para manejar la selección de una cuenta
    const handleCuentasSelect = (prov, isSelected) => {
        if (isSelected) {
            setselectedCuentas([...selectedCuentas, prov]);
        } else {
            setselectedCuentas(selectedCuentas.filter(u => u.id !== prov.id));
            setSelectAll(false); // Desactivar el checkbox de la cabecera si un proyecto se deselecciona
        }
    };

    // Función para manejar el cambio en el checkbox de la cabecera
    const handleSelectAllChange = () => {
        setSelectAll(!selectAll);

        if (!selectAll) {
            setselectedCuentas(currentItems);
        } else {
            setselectedCuentas([]);
        }
    };

    const handleShowModalMulti = () => {
        setShowMultiDeleteModal(true);
        setDropdownOpen({});
    };

    // Función para manejar la eliminación de Cuentas seleccionados
    const handleDeleteselectedCuentas = async () => {

        setIsLoading(true);
        try {

            // Extrae solo los IDs de cada cuenta
            const CuentasIds = selectedCuentas.map(account => account.id);

            const results = await deleteAccountsByIds(CuentasIds);
            const successfulDeletes = results.filter(result => result.success).map(result => result.id);
            const failedDeletes = results.filter(result => !result.success);

            // Actualizar el estado para excluir las Cuentas eliminados exitosamente
            setCuentas(prevCuentas => prevCuentas.filter(pr => !successfulDeletes.includes(pr.id)));

            // Desactivar el checkbox de la cabecera
            setSelectAll(false);

            // Limpiar la lista de Cuentas seleccionados
            setselectedCuentas([]);

            // Cerrar el modal una vez que se haya completado la eliminación
            setShowMultiDeleteModal(false);

            if ((successfulDeletes.length === selectedCuentas.length) && (successfulDeletes.length > 0)) {
                props.ShowDone(`Se eliminaron ${successfulDeletes.length} Cuentas`);
            } else {

                if (successfulDeletes.length === 1) {
                    props.ShowDone(`Se elimino la cuenta: ${successfulDeletes[0].name} `);
                } else if (successfulDeletes.length > 0) {
                    props.ShowDone(`Se eliminaron ${successfulDeletes.length} Cuentas`);
                }

                failedDeletes.forEach(failed => {
                    props.showErr(`La cuenta no se pudo eliminar.`);
                    props.ShowWar(failed.message);
                });
            }

            setIsLoading(false);

        } catch (error) {
            props.showErr('Ocurrio un error inesperado.');
            console.log(error);
            setIsLoading(false);
        }

    };

    const handleModalDelete = (provID) => {
        const accountToDelete = Cuentas.find(u => u.id === provID);
        if (accountToDelete) {
            deleteCuentas(accountToDelete);
        }
        setShowModalForaccountId(null);  // Cerrar el modal
    };


    return (
        <>
            {!loading && (
                <div>
                    < HeaderHome
                        userLoged={useUser}
                    />

                    <div className='bodyHome-user' style={{ height: "210vh" }}>
                        < Menu
                            userLoged={useUser}
                        />
                        <div style={{ width: "100%" }}>
                            <p>Cuentas Bancarias</p>
                            <div className='filter-use-p'>
                                <div className='filter-use'>
                                    <form style={{ width: "80%" }}>
                                        <div className='filter-userDetails'>
                                            <label>Nombre</label>
                                            <label>Banco</label>
                                            <label>Tipo de Cuenta</label>
                                            <div className="input-with-icon">
                                                <input
                                                    id='nombre'
                                                    name='nombre'
                                                    onChange={InputChangeUsr}
                                                    placeholder="Escribe el nombre de la Cuenta"
                                                    value={searchName}
                                                />
                                                {searchName &&
                                                    <AiFillCloseCircle className="close-icon-name" onClick={() => {
                                                        setSearchName('');
                                                        // limpiar local storage
                                                        saveFiltersToLocalStorage({
                                                            searchName: '',
                                                            SearchBanco,
                                                            SearchTipo
                                                        });
                                                        document.getElementById('nombre').value = '';
                                                        document.getElementById('nombre').classList.remove('input-active');
                                                    }} />}
                                            </div>
                                            <div className="input-with-icon">
                                                <input
                                                    id='searchbanco'
                                                    name='searchbanco'
                                                    onChange={InputChangeUsr}
                                                    placeholder="Escribe el nombre del Banco"
                                                    value={SearchBanco}
                                                />
                                                {SearchBanco &&
                                                    <AiFillCloseCircle className="close-icon-name" onClick={() => {
                                                        setSearchBanco('');
                                                        // limpiar local storage
                                                        saveFiltersToLocalStorage({
                                                            searchName,
                                                            SearchBanco: '',
                                                            SearchTipo
                                                        });
                                                        document.getElementById('searchbanco').value = '';
                                                        document.getElementById('searchbanco').classList.remove('input-active');
                                                    }} />}
                                            </div>
                                            <div className="input-with-icon">
                                                <input
                                                    id='searchtipo'
                                                    name='searchtipo'
                                                    onChange={InputChangeUsr}
                                                    placeholder="Escribe tipo de la Cuenta"
                                                    value={SearchTipo}
                                                />
                                                {SearchTipo &&
                                                    <AiFillCloseCircle className="close-icon-name" onClick={() => {
                                                        setSearchTipo('');
                                                        // limpiar local storage
                                                        saveFiltersToLocalStorage({
                                                            searchName,
                                                            SearchBanco,
                                                            SearchTipo: ''
                                                        });
                                                        document.getElementById('searchtipo').value = '';
                                                        document.getElementById('searchtipo').classList.remove('input-active');
                                                    }} />}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <Link to="/cuentas/nuevo">
                                    <button className='filter-use-button'>+ Crear nueva cta.</button>
                                </Link>
                            </div>
                            <div className='delete-users' >
                                <button onClick={handleShowModalMulti} style={{ cursor: "pointer" }}><FiTrash2></FiTrash2> Eliminar</button>
                            </div>
                            {showMultiDeleteModal &&
                                <Modal
                                    selectedAccounts={selectedCuentas}
                                    itypeialOpen={true}
                                    close={() => setShowMultiDeleteModal(false)}
                                    onDelete={handleDeleteselectedCuentas}
                                />
                            }
                            <div className='user-details'>
                                <table className='tabla-usuarios'>
                                    <thead>
                                        <tr className='tabla-header'>
                                            <th style={{ paddingTop: "2%", paddingBottom: "2%", paddingLeft: "3%", width: "7%" }}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectAll}
                                                    onChange={handleSelectAllChange}
                                                />
                                            </th>
                                            <th style={{ width: "30%" }}>Nombre</th>
                                            <th style={{ width: "15%" }}>Banco</th>
                                            <th style={{ width: "15%" }}>Número de cuenta</th>
                                            <th>Tipo de Cuenta</th>
                                            <th>Acciones</th>
                                        </tr>
                                        <tr className="separator">
                                            <td colSpan="6"></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentItems.map((account, index) => (
                                            <React.Fragment key={account.id}>
                                                <tr key={account.id} >
                                                    <td style={{ paddingLeft: "3%" }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedCuentas.some(u => u.id === account.id)}
                                                            onChange={e => handleCuentasSelect(account, e.target.checked)}
                                                        />
                                                    </td>
                                                    <td style={{ height: "9vh" }}>{account.name}</td>
                                                    <td>{account.bank ? account.bank : ''}</td>
                                                    <td>{account.account_number ? account.account_number : ''}</td>
                                                    <td>{account.type ? account.type : ''}</td>
                                                    <td style={{ paddingLeft: "2%" }}>
                                                        <div className='menu-usuarios' ref={dropdownRef} onClick={(e) => e.stopPropagation()}>
                                                            <button className="icon-button" onClick={() => toggleDropdown(account.id)}><CiMenuKebab /></button>

                                                            {!showMultiDeleteModal && dropdownOpen[account.id] && (
                                                                <div className="dropdownMenu">
                                                                    <ul>
                                                                        <li><a className="dontCloseDropdown" onClick={() => goToEditaccount(account)}><GrFormEdit></GrFormEdit>Editar</a></li>
                                                                        <li><a className="dontCloseDropdown" onClick={() => { setShowModalForaccountId(account.id); setDropdownOpen({}); }}><FiTrash2></FiTrash2>Eliminar</a></li>
                                                                    </ul>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr className="separator">
                                                    <td colSpan="6"></td>
                                                </tr>
                                            </React.Fragment>
                                        ))}
                                    </tbody>
                                </table>
                                <div className='paginador-usuarios'>
                                    <span>{currentPage} de {totalPages} </span>
                                    <div>
                                        <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}><MdArrowBackIosNew /> Anterior</button>
                                        {currentPage > 1 && <button onClick={() => paginate(currentPage - 1)}>{currentPage - 1}</button>}
                                        <button style={{ fontWeight: "bold" }} className={currentPage === currentPage ? "selected-page" : ""}>{currentPage}</button>
                                        {currentPage < totalPages && <button onClick={() => paginate(currentPage + 1)}>{currentPage + 1}</button>}
                                        <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>Siguiente <MdArrowForwardIos /></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                </div >
            )
            }
            {
                showModalForaccountID &&
                <Modal
                    account={Cuentas.find(u => u.id === showModalForaccountID)}
                    itypeialOpen={true}
                    close={() => setShowModalForaccountId(null)}
                    onDelete={() => handleModalDelete(showModalForaccountID)}
                />
            }
            {isLoading && <LoadingModal />}
        </>
    );
}

export default CuentasBanco;